import type { Locale } from './en';

const ar: Locale = {
  meta: { code: 'AR', label: 'العربية', dir: 'rtl' },
  nav: {
    howItWorks: 'كيف يعمل',
    fees: 'الرسوم',
    coins: 'العملات',
    faq: 'الأسئلة',
    about: 'من نحن',
    pepetual: 'Pepetual',
    support: 'الدعم',
    launchApp: 'افتح التطبيق',
    marketsOpen: 'الأسواق مفتوحة',
  },
  ticker: { liveMarkets: 'أسواق مباشرة' },
  home: {
    heroEyebrow: 'بدون KYC · غير حافظ · أكثر من 900 عملة',
    heroTitlePre: 'بدّل العملات الرقمية',
    heroTitleMid: 'وكأنّ',
    heroTitleAccent: 'الأسواق',
    heroTitlePost: 'تراقب.',
    heroLead:
      'أسعار سوقية حيّة لأكثر من 900 عملة رقمية. بدون حسابات، بدون فحوصات هوية، بدون حيازة. أنت ترسل، والشبكة تبدّل، ومحفظتك تستقبل — عادةً خلال 30 دقيقة.',
    exchangeOperatorHeading: 'مشغّل المبادلة',
    exchangeOperatorNote: 'ChangeNOW شريكنا للسيولة وتتولى تشغيل جميع المبادلات. لأي سؤال عن معاملة، تواصل مع دعم ChangeNOW وأرسل TXID الظاهر في صفحة الحالة.',
    transactionSupportCta: 'تواصل مع دعم ChangeNOW',
    startSwapping: 'ابدأ المبادلة',
    howItWorks: 'كيف يعمل',
    heroStats: { coins: 'العملات', avgSettle: 'متوسط التسوية', kyc: 'KYC', liveRates: 'أسعار حيّة' },
    marketsEyebrow: 'الأسواق',
    marketsTitle: 'أزواج المبادلة الأكثر شيوعاً',
    marketsDesc:
      'روابط مباشرة إلى أكثر المسارات تداولاً على ShieldMyAss. كل زوج يحمّل الأداة جاهزةً مسبقاً لتبادل خلال ثوانٍ.',
    processEyebrow: 'العملية',
    processTitle: 'ثلاث خطوات. هذا كل المنتج.',
    processDesc: 'بدون حسابات، بدون إيداع رصيد، بدون مفاتيح API. مجرد مبادلة.',
    assetsEyebrow: 'الأصول',
    assetsTitle: 'العملات التي تحرّك السوق',
    assetsDesc: 'سيولة عميقة عبر العملات الرئيسية، وعملات الخصوصية، والعملات المستقرة والسلع المُرمَّزة.',
    whyEyebrow: 'لماذا ShieldMyAss',
    whyTitle: 'مصمَّم لمن يقدّرون الخصوصية.',
    whyDesc: 'كل قرار تصميمي يبدأ بسؤال واحد: كيف نجعل هذه الصفقة خاصة وسريعة وعادلة قدر الإمكان؟',
    questionsEyebrow: 'الأسئلة',
    questionsTitle: 'أسئلة جيدة، وإجابات صادقة.',
    seeAllFaqs: 'عرض كل الأسئلة',
  },
  steps: [
    { title: 'اختر زوجك', text: 'اختر من أكثر من 900 عملة. من بيتكوين إلى مونيرو، ومن ETH إلى USDT — اختر ما ترسله وما تستقبله.' },
    { title: 'أدخل عنوانك', text: 'الصق عنوان محفظة العملة التي تريد استلامها. نتحقّق منه وفق شبكة الوجهة.' },
    { title: 'أرسل، ارتاح، استقبل', text: 'أرسل إيداعك إلى العنوان المُولَّد. تتبّع كل خطوة مباشرةً حتى تصل العملات إلى محفظتك.' },
  ],
  trustPoints: [
    { icon: 'shield', title: 'لا KYC أبداً', text: 'بدّل دون فحوصات هوية أو بريد أو حسابات.' },
    { icon: 'lock', title: 'غير حافظ', text: 'تتدفّق الأموال مباشرةً من محفظتك إلى محفظتك.' },
    { icon: 'bolt', title: 'تسوية خلال 5–30 دقيقة', text: 'تتبّع حالة مباشر لكل صفقة.' },
    { icon: 'globe', title: 'أكثر من 900 عملة', text: 'من بيتكوين إلى مونيرو، ومن العملات المستقرة إلى رموز الذهب.' },
  ],
  stats: [
    { num: '900', unit: '+', label: 'عملة مدعومة' },
    { num: '30', unit: '+', label: 'بلوك تشين' },
    { num: '5', unit: 'دقائق', label: 'متوسط التسوية' },
    { num: '0', unit: '%', label: 'مطلوب KYC' },
  ],
  cta: {
    eyebrow: 'جاهزون متى كنت',
    titleA: 'بدّل خلال دقائق.',
    titleB: 'بدون حساب، بدون KYC.',
    desc: 'اختر زوجك، الصق عنوانك، ودع الشبكة تتولّى الباقي. عملاتك تذهب مباشرةً إلى محفظتك — لا نحتفظ بها أبداً.',
    startSwapping: 'ابدأ المبادلة',
    browseCoins: 'تصفّح العملات',
  },
  footer: {
    brandDesc:
      'منصّة مبادلة عملات رقمية بدون KYC وغير حافظة. بدّل أكثر من 900 عملة بأسعار سوقية حيّة — مفاتيحك، عملاتك، شأنك.',
    allSystemsOperational: 'كل الأنظمة تعمل',
    colProduct: 'المنتج',
    colPairs: 'أزواج شهيرة',
    colCompany: 'الشركة',
    feesRates: 'الرسوم والأسعار',
    supportedCoins: 'العملات المدعومة',
    launchExchange: 'افتح المبادلة',
    disclaimer:
      'ShieldMyAss خدمة مبادلة غير حافظة. ينطوي تداول العملات الرقمية على مخاطر كبيرة. الأسعار متقلّبة والأداء السابق لا يضمن المستقبلي. تحقّق دائماً من عنوان الإيداع والشبكة قبل الإرسال. ChangeNOW شريكنا للسيولة وتتولى تشغيل جميع عمليات المبادلة.',
    copyright: 'جميع الحقوق محفوظة.',
  },
  exchange: {
    instantSwap: 'مبادلة فورية · بدون KYC',
    transactionLive: 'الصفقة مباشرة',
    youSend: 'ترسل أنت',
    youReceive: 'تستقبل أنت',
    estimated: 'تقديري',
    min: 'الأدنى: {amount} {ticker}',
    destinationAddress: 'عنوان الاستلام',
    addressValid: 'يبدو العنوان صالحاً',
    enterAmount: 'أدخل مبلغاً لرؤية السعر الحيّ.',
    fetchingRate: 'نجلب السعر الحيّ…',
    increaseAmount: 'زد المبلغ (الأدنى {amount} {ticker})',
    exchangeNow: 'بادل الآن',
    creatingSwap: 'نُنشئ مبادلتك…',
    nonCustodialNote: 'غير حافظ · الأموال تذهب مباشرةً إلى محفظتك',
    poweredBy: 'تُشغّل ChangeNOW جميع المبادلات',
    newExchange: 'مبادلة جديدة',
    invalidAddress: 'عنوان الوجهة لا يبدو صالحاً. يرجى التحقّق وإعادة المحاولة.',
    minAmountError: 'الحد الأدنى لهذا الزوج هو {amount} {ticker}.',
    createError: 'تعذّر إنشاء المعاملة. حاول مرة أخرى.',
    pickerTitleFrom: 'ترسل أنت',
    pickerTitleTo: 'تستقبل أنت',
    pickerSub: 'اختر عملة رقمية',
    pickerPopular: 'الأكثر شيوعاً',
    pickerAll: 'كل الأصول',
    pickerSearch: 'ابحث بالاسم أو الرمز أو الشبكة…',
    pickerEmpty: 'لا عملات تطابق «{query}».',
    pickerFooter: '{count} أصل · بيانات حيّة من شبكة السيولة',
  },
  pages: {
    howItWorks: {
      eyebrow: 'العملية',
      title: 'من الإرسال إلى الاستلام، في خمس خطوات.',
      lead: 'بدون حسابات، بدون إيداع رصيد، بدون مفاتيح API. مبادلة نظيفة من أي محفظة إلى أي محفظة، عادةً خلال ثلاثين دقيقة.',
      detail: [
        { title: 'اختر زوجك', body: 'اختر العملة التي ترسلها والعملة التي تريد استلامها. ندعم أكثر من 900 أصل عبر أكثر من 30 بلوك تشين، والأزواج الشائعة مثبّتة أعلى كل قائمة.', points: ['BTC و ETH و SOL و XMR وجميع شبكات L1 الرئيسية', 'USDT و USDC على أكثر من 5 شبكات', 'الذهب المُرمَّز (XAUT) والعملات المستقرة'] },
        { title: 'أدخل المبلغ', body: 'اكتب المبلغ الذي تريد إرساله. تستعلم الأداة فوراً من شبكة السيولة الشريكة عن سعر حيّ وتعرض لك المبلغ الدقيق الذي ستتلقّاه قبل التزامك بأي شيء.', points: ['تتحدّث الأسعار كل 10 ثوانٍ', 'تُعرض الحدود الدنيا للشبكة فوراً', 'لا انزلاق سعري على الصفقات القياسية'] },
        { title: 'الصق عنوان الاستلام', body: 'أدخل عنوان المحفظة التي تريد استلام العملة الهدف عليها. نجري فحص تنسيق وفق شبكة الوجهة حتى يُكتشف الخطأ المطبعي قبل أموالك.', points: ['تحقّق عنوان لكل شبكة', 'بدون بريد أو هاتف أو حساب', 'العنوان هو البيانات الشخصية الوحيدة التي نلمسها'] },
        { title: 'أرسل الإيداع', body: 'يُولَّد عنوان إيداع لمرة واحدة لصفقتك. أرسل المبلغ المضبوط إليه من أي محفظة — أجهزة أو جوّال أو سطح مكتب أو بورصة. تبقى نافذة الإيداع مفتوحةً طويلاً بما يكفي للشبكات البطيئة.', points: ['عنوان إيداع فريد لكل صفقة', 'رمز QR لمحافظ الجوّال', 'أرسل العملة المختارة فقط'] },
        { title: 'تتبّع كل مرحلة', body: 'تتحدّث صفحة الحالة تلقائياً. ترى تأكيد الإيداع وتنفيذ المبادلة وبثّ الإخراج لحظياً. لا حاجة لزر تحديث — رغم أنّنا نوفّر واحداً.', points: ['شريط تقدّم من 5 مراحل', 'هاشات معاملات داخلة وخارجة حيّة', 'تحديث تلقائي كل 10 ثوانٍ'] },
      ],
      faqEyebrow: 'الأسئلة',
      faqTitle: 'ما يسأله الناس قبل المبادلة',
    },
    fees: {
      eyebrow: 'التسعير',
      title: 'السعر الذي تراه هو السعر الذي تحصل عليه.',
      lead: 'بدون رسوم خدمة، بدون رسوم سحب، بدون اشتراك. التكلفة الوحيدة هي فرق سعري صغير مدمج في السعر الحيّ من شريك السيولة.',
      zeroTitle: 'صفر رسوم خفية',
      zeroDesc: 'كل ما يلي يُعرض لك في الأداة قبل التزامك بالصفقة.',
      tableHeaders: ['البند', 'التكلفة', 'المعنى'],
      rows: [
        { label: 'رسوم الخدمة', value: '0%', note: 'لا نضيف شيئاً فوق سعر الشبكة.' },
        { label: 'الفرق السعري للشبكة', value: '0.25–0.9%', note: 'مدمج في السعر من شريك السيولة.' },
        { label: 'أدنى صفقة', value: '~2$', note: 'حد أدنى لكل زوج، ظاهر حيّاً في الأداة.' },
        { label: 'أقصى صفقة', value: 'بلا سقف صارم', note: 'قد تُقسَّم الصفقات الكبيرة لحماية السعر.' },
        { label: 'رسوم الحيازة', value: '0%', note: 'لا نحتفظ بأموالك، فلا شيء نأخذ مقابل رسوم.' },
        { label: 'رسوم الحساب', value: '0%', note: 'لا يوجد حساب.' },
      ],
      includedEyebrow: 'ما المتضمَّن',
      includedTitle: 'أمور لن تقلق بشأنها',
      included: [
        'السعر المعروض في الأداة هو السعر الذي تتلقّاه.',
        'تُظهر الشبكة الحدود الدنيا فوراً — بلا مفاجآت منتصف الصفقة.',
        'بدون إيداع رصيد، بدون سقوف سحب، بدون تسعير متدرّج.',
        'قد تُمرَّر الصفقات الكبيرة جداً تلقائياً عبر أماكن سيولة متعددة لتقليل الانزلاق.',
      ],
    },
    about: {
      eyebrow: 'من نحن',
      title: 'أردنا فقط مبادلة تحترمنا.',
      lead: 'وُجد ShieldMyAss لأن كل بورصة أخرى أرادت جواز سفرنا قبل أن تدعنا نحوّل 50$ من مونيرو. رأينا أنّ ذلك خطأ، فبنينا البديل.',
      valuesEyebrow: 'القيم',
      valuesTitle: 'أربعة مبادئ، بلا استثناء.',
      values: [
        { icon: 'eye', title: 'الخصوصية أولاً', text: 'بدون KYC، بدون بريد، بدون تتبّع. عنوان استلامك هو المعلومة الوحيدة التي نراها، وننساها لحظة إتمام الصفقة.' },
        { icon: 'lock', title: 'غير حافظ', text: 'لا نحتفظ بعملاتك أبداً. تتدفّق الأموال مباشرةً من عنوان إيداع لمرة واحدة إلى محفظتك عبر مبادلة الشبكة. لا يوجد رصيد ShieldMyAss يمكن اختراقه.' },
        { icon: 'bolt', title: 'السرعة ميزة', text: 'نهتم بالزمن — من تحديث السعر كل 10 ثوانٍ إلى صفحة الحالة ذاتية التحديث. يجب أن تبدو المبادلة مبادلة، لا استمارة.' },
        { icon: 'feather', title: 'بساطة جذرية', text: 'شاشة واحدة. مهمة واحدة. نزيل كل ما ليس الصفقة. لا رسوم بيانية لم تطلبها، ولا بيع متزايد، ولا رموز.' },
      ],
      storyEyebrow: 'القصة',
      storyTitle: 'كيف وصلنا إلى هنا',
      timeline: [
        { year: 'لماذا وُجدنا', text: 'بُني ShieldMyAss على يد أناس سئموا من تدفقات الإلحاق في البورصات التي تطالب بوثائق الهوية لمبادلة 50$. أردنا أداة تحترم وعد العملات الرقمية الأصلي: خاصة، نظير لنظير، غير قابل للعكس.' },
        { year: 'كيف نعمل', text: 'ChangeNOW شريكنا للسيولة وتتولى تشغيل جميع المبادلات. توفّر ShieldMyAss الواجهة وتعرض حالة المعاملة مباشرةً. يُدمج فرق سعري صغير في السعر المعروض، ولا نبيع بياناتك أبداً.' },
        { year: 'ما لن نفعله', text: 'لن نطلب أبداً وثائق الهوية للمبادلات القياسية. ولن نحوز أموالك أبداً. ولن نصدر رمزاً لـ«مكافأة» المستخدمين. إن تغيّر ذلك، سنخبرك على الصفحة الرئيسية.' },
      ],
    },
    contact: {
      eyebrow: 'تواصل',
      title: 'هل تحتاج إلى مساعدة بشأن مبادلة؟',
      lead: 'لحالة المعاملة أو التأخير أو الاسترداد أو أي سؤال عن المبادلة، تواصل مباشرةً مع ChangeNOW وأرسل TXID الظاهر في صفحة الحالة. للاستفسارات عن موقع ShieldMyAss، راسلنا أدناه.',
      transactionSupportEyebrow: 'دعم المعاملات',
      transactionSupportTitle: 'ChangeNOW تشغّل جميع المبادلات',
      transactionSupportDesc: 'تستخدم ShieldMyAss خدمة ChangeNOW كشريك للسيولة، وتتولى ChangeNOW تشغيل جميع المبادلات. يمكن لدعم ChangeNOW العثور على معاملتك. أرسل TXID الكامل الظاهر في صفحة الحالة.',
      transactionSupportCta: 'تواصل مع دعم ChangeNOW',
      support: 'دعم الموقع',
      email: 'البريد',
      beforeTitle: 'قبل مراسلتنا',
      before: [
        'لحالة المعاملة أو التأخير أو الاسترداد، تواصل مع ChangeNOW عبر الرابط أعلاه وأرسل TXID الكامل.',
        'للاستفسارات عن الموقع، راسل فريق الدعم لدينا.',
        'لا تشارك عبارة استرداد محفظتك أو مفاتيحك الخاصة مع أي شخص.',
        'نردّ على رسائل دعم الموقع خلال 24 ساعة، وغالباً أسرع خلال ساعات العمل الأوروبية.',
      ],
      securityTitle: 'بلاغات الأمان',
      securityDesc: 'وجدت ثغرة؟ راسلنا مع وضع «SECURITY» في الموضوع. نردّ بسرعة ونُنسب الفضل للإفصاح المسؤول.',
    },
    faq: {
      eyebrow: 'مساعدة',
      title: 'الأسئلة الشائعة.',
      lead: 'كل ما قد تودّ معرفته قبل المبادلة وأثناءها وبعدها.',
      transactionSupportEyebrow: 'دعم المعاملات',
      transactionSupportTitle: 'هل تحتاج إلى مساعدة بشأن معاملة؟',
      transactionSupportDesc: 'تستخدم ShieldMyAss خدمة ChangeNOW كشريك للسيولة، وتتولى ChangeNOW تشغيل جميع المبادلات. لأي سؤال عن معاملة، تواصل مباشرةً مع دعم ChangeNOW وأرسل مُعرّف المعاملة الكامل (TXID) الظاهر في صفحة الحالة.',
      transactionSupportCta: 'تواصل مع دعم ChangeNOW',
    },
    coins: {
      eyebrow: 'الأصول',
      title: 'أكثر من 900 عملة. أكثر من 30 شبكة.',
      lead: 'كل شيء من بيتكوين إلى الذهب المُرمَّز. القائمة الحيّة أدناه تأتي مباشرةً من شريك السيولة.',
      spotlightEyebrow: 'تحت الضوء',
      spotlightTitle: 'أصول مميّزة',
      catalogueEyebrow: 'الفهرس',
      catalogueTitle: 'قائمة الدعم الكاملة',
      allChips: 'الكل',
      searchPlaceholder: 'ابحث عن عملات أو شبكات...',
      showingFirst: 'عرض أول 300 من أصل {total}. حسّن بحثك لرؤية المزيد.',
      noMatch: 'لا عملات تطابق «{query}».',
    },
    notFound: {
      eyebrow: 'فقد الإشارة',
      title: 'خارج الشبكة.',
      desc: 'هذه الصفحة غير موجودة. الخبر السار: أداة المبادلة على بُعد نقرة واحدة.',
      backToSwap: 'العودة للمبادلة',
      browseCoins: 'تصفّح العملات',
    },
    exchangePair: {
      eyebrow: 'سعر حيّ · بدون KYC',
      aboutEyebrow: 'عن هذا الزوج',
      aboutTitle: 'حول زوج {from} / {to}',
      aboutBody:
        'هذه الصفحة مسار مخصّص لمبادلة {fromName} إلى {toName} على ShieldMyAss. الأداة أعلاه معدّة مسبقاً بإرسال {from} واستقبال {to}، لذا يمكنك لصق عنوان {to} وإرسال {from} دون تغيير أي شيء.',
      beforeTitle: 'قبل أن ترسل',
      beforeDesc: 'تحقّق دائماً من أنّ عنوان استلامك على الشبكة الصحيحة، وأنّك ترسل على الأقل الحد الأدنى الظاهر في الأداة.',
      moreEyebrow: 'مسارات أخرى',
      moreTitle: 'أزواج شهيرة أخرى',
      faqEyebrow: 'الأسئلة',
      faqTitle: 'إجابات سريعة',
    },
    privacy: {
      eyebrow: 'قانوني',
      title: 'سياسة الخصوصية',
      lead: 'مختصرة، بلغة بسيطة. آخر تحديث {date}.',
      calloutTitle: 'النسخة المختصرة',
      calloutText: 'لا نطلب هويتك، ولا نتتبّعك عبر الويب، ولا نبيع البيانات. البيانات الشخصية الوحيدة التي نعالجها هي عنوان المحفظة الذي تقدّمه للصفقة، وننساه عند إتمامها.',
      sections: [
        { h: '1. من نحن', p: ['يُشغّل {SITE} («نحن») خدمة مبادلة عملات رقمية غير حافظة متاحة على {DOMAIN}. ChangeNOW شريكنا للسيولة وتتولى تشغيل جميع المبادلات.'] },
        { h: '2. البيانات التي نجمعها', p: [], ul: ['<strong>عنوان الاستلام.</strong> عنوان المحفظة الهدف الذي تُدخله للصفقة.', '<strong>مُعاملات الصفقة.</strong> الزوج والمبلغ ومُعرّفات المعاملات الناتجة اللازمة لتنفيذ المبادلة وتتبّعها.', '<strong>سجلّات تقنية.</strong> عنوان IP ووكيل المستخدم والطوابع الزمنية، محفوظة لفترة قصيرة لمنع الإساءة وحلّ النزاعات.', '<strong>ما لا نجمعه:</strong> الاسم، البريد، الهاتف، وثائق الهوية، بطاقات الدفع، أو أي بيانات KYC/AML.'] },
        { h: '3. لماذا نعالجها', p: ['نُعالج البيانات أعلاه حصراً لتنفيذ مبادلتك المطلوبة، ومنع الاحتيال والإساءة، والامتثال للطلبات القانونية حيثما ينطبق، وحلّ النزاعات بشأن صفقة محدّدة.'] },
        { h: '4. مدة الاحتفاظ', p: ['تُحفظ سجلّات الصفقة (الزوج، المبلغ، العناوين، مُعرّفات المعاملات) طوال المبادلة بالإضافة إلى نافذة محدودة للدعم وحلّ النزاعات. تُدار السجلّات التقنية وفق جدول قصير. لا نحتفظ بملفات طويلة الأمد مرتبطة بالهوية.'] },
        { h: '5. ملفات تعريف الارتباط', p: ['لا يستخدم {SITE} ملفات تتبّع. أي تخزين تستخدمه المنصّة (مثل حفظ موضع التمرير في قائمة العملات) هو تخزين وظيفي صِرف من الطرف الأول ويُمسح عند إغلاق المتصفّح.'] },
        { h: '6. أطراف ثالثة', p: ['تُنفَّذ المبادلات وتُدار بواسطة ChangeNOW، شريكنا للسيولة. عند بدء صفقة، تُشارَك المُعاملات اللازمة لتنفيذها مع ChangeNOW. سياستهم متاحة على changenow.io/privacy-policy.'] },
        { h: '7. حقوقك', p: ['بحسب ولايتك القضائية، قد يكون لك حقوق في الوصول إلى بياناتك الشخصية أو تصحيحها أو حذفها. بما أنّنا لا نجمع بيانات بمستوى الهوية، فإنّ هذه الحقوق تنطبق عادةً فقط على سجلّات الصفقة المرتبطة بعنوان محدّد. تواصل معنا لممارستها.'] },
        { h: '8. الأمان', p: ['{SITE} غير حافظ: لا نحتفظ بأموال المستخدمين في أي لحظة. يتحكّم شريك السيولة بعنوان الإيداع المُولَّد لكل صفقة لغرض تنفيذ تلك الصفقة وحده. نستخدم HTTPS في كل مكان ونُدير بيانات اعتماد البنية التحتية بانتظام.'] },
        { h: '9. تغييرات على السياسة', p: ['إذا غيّرنا ما نجمعه أو لماذا، سنحدّث هذه الصفحة ونرفع تاريخ «آخر تحديث». لن نوسّع بأثر رجعي الجمع ليشمل بيانات الهوية دون إفصاح واضح هنا.'] },
        { h: '10. تواصل', p: ['أسئلة حول الخصوصية؟ راسلنا.'] },
      ],
    },
    terms: {
      eyebrow: 'قانوني',
      title: 'شروط الخدمة',
      lead: 'آخر تحديث {date}.',
      calloutTitle: 'ملخّص بلغة بسيطة',
      calloutText: 'تستخدم {SITE} لمبادلة العملات الرقمية. نحن نوفّر التوجيه، والشبكة توفّر التنفيذ. أنت مسؤول عن العناوين والمبالغ التي تُدخلها. العملات الرقمية متقلّبة وغير قابلة للعكس — بدّل فقط ما تستطيع خسارته.',
      sections: [
        { h: '1. قبول الشروط', p: ['بدخولك {DOMAIN} فإنّك توافق على هذه الشروط. إذا لم توافق، فلا تستخدم الخدمة.'] },
        { h: '2. الخدمة', p: ['توفّر {SITE} واجهة مبادلة عملات رقمية غير حافظة وتعرض الأسعار الحيّة وحالة المعاملة. ChangeNOW شريكنا للسيولة وتتولى تشغيل جميع المبادلات. لا نحوز الأموال ولا نحتفظ بأرصدة ولا نشغّل دفتر أوامر.'] },
        { h: '3. الأهلية', p: ['يجب أن تكون في السن القانوني في ولايتك القضائية وألّا تكون في إقليم مقيّد. أنت مسؤول عن الالتزام بقوانين ولايتك القضائية، بما في ذلك أي قيود على معاملات العملات الرقمية.'] },
        { h: '4. مسؤولياتك', p: [], ul: ['يجب أن تقدّم عنوان استلام صالحاً لشبكة الوجهة. العناوين الخاطئة قد تؤدّي إلى خسارة دائمة.', 'يجب أن ترسل الأصل الصحيح إلى عنوان الإيداع. إيداع أصل خاطئ قد لا يُستعاد.', 'يجب أن ترسل على الأقل الحد الأدنى للشبكة الظاهر في الأداة. المبالغ الأصغر قد لا تُعالَج.', 'أنت وحدك مسؤول عن أي التزامات ضريبية تنشأ عن صفقاتك.'] },
        { h: '5. الأسعار والرسوم', p: ['الأسعار استرشادية حتى إنشاء الصفقة وقد تتغيّر بين مشاهدة الأداة وتأكيد إيداعك. فرق سعري صغير مدمج في السعر من شريك السيولة؛ لا يفرض {SITE} رسوم خدمة إضافية. تُظهر الشبكة الحدود الدنيا فوراً.'] },
        { h: '6. نهائية المعاملة', p: ['بمجرّد استلام الإيداع وتأكيده على شبكته، تُنفَّذ المبادلة ويُبثّ الإخراج إلى عنوان استلامك. معاملات البلوك تشين غير قابلة للعكس عموماً. إذا فشلت المبادلة على مستوى الشبكة، يُعاد المبلغ الوارد من الشريك إلى العنوان الأصلي.'] },
        { h: '7. عدم وجود ضمانات', p: ['تُقدَّم الخدمة «كما هي» دون ضمانات من أي نوع. لا نضمن توفّراً متواصلاً أو أسعاراً محدّدة أو إتمام مبادلة ضمن إطار زمني معيّن، إذ تعتمد هذه الأمور على شبكات طرف ثالث خارج سيطرتنا.'] },
        { h: '8. تحديد المسؤولية', p: ['في أقصى حد يسمح به القانون، لا يكون {SITE} مسؤولاً عن أضرار غير مباشرة أو عرضية أو تبعية، أو عن أي خسارة ناشئة عن خطأ المستخدم (بما في ذلك عناوين خاطئة أو إيداع أصل خاطئ). تُحدّد مسؤوليتنا الإجمالية عن أي مطالبة بالفرق الذي كسبناه من الصفقة المعيّنة محلّ النزاع.'] },
        { h: '9. الاستخدامات الممنوعة', p: ['لا يجوز لك استخدام {SITE} لغسل الأموال أو تمويل الإرهاب أو التهرّب من العقوبات أو أي نشاط غير قانوني. قد نرفض صفقة أو نلغيها عندما يكون لدينا سبب للاعتقاد بارتباطها بنشاط من هذا القبيل.'] },
        { h: '10. تغييرات الشروط', p: ['قد نحدّث هذه الشروط من حين لآخر. تُنعكس التغييرات الجوهرية بتحديث تاريخ «آخر تحديث». الاستمرار في الاستخدام بعد التغييرات يُعدّ قبولاً.'] },
        { h: '11. تواصل', p: ['أسئلة حول هذه الشروط؟ راسلنا.'] },
      ],
    },
  },
  faqs: [
    { q: 'هل ShieldMyAss فعلاً بدون KYC؟', a: 'نعم. لا نطلب أبداً وثائق هويتك أو بريدك أو رقم هاتفك. تستخدم ShieldMyAss خدمة ChangeNOW كشريك للسيولة وتتولى ChangeNOW تشغيل جميع المبادلات. لا يُطلب التحقق من الهوية للمبالغ القياسية. عنوان استلامك هو المعلومة الوحيدة التي نحتاجها.' },
    { q: 'كم تستغرق المبادلة؟', a: 'تكتمل معظم المبادلات خلال 5–30 دقيقة. يعتمد الوقت الدقيق على الشبكة التي ترسل منها والشبكة التي تستقبل عليها. تأكيدات بيتكوين تستغرق أطول من سولانا أو ترون مثلاً. يمكنك مشاهدة كل مرحلة — الإيداع، التأكيد، المبادلة، الإرسال — مباشرةً على صفحة الحالة.' },
    { q: 'ماذا أفعل إذا واجهت مشكلة في معاملتي؟', a: 'تتولى ChangeNOW تشغيل جميع المبادلات عبر ShieldMyAss. تواصل مباشرةً مع دعم ChangeNOW عبر changenow.com/contact وأرسل مُعرّف المعاملة الكامل (TXID) الظاهر في صفحة الحالة ليتمكن الفريق من العثور على المبادلة والتحقق من حالتها.' },
    { q: 'ما هي الرسوم؟', a: 'السعر الذي تراه هو السعر الذي تحصل عليه. يفرض ShieldMyAss 0% فوق سعر الشبكة؛ يُدمج شريك السيولة فرقاً سعرياً صغيراً (عادةً 0.25%–0.9%) داخل السعر المُقوَّم. لا رسوم خدمة خفية، ولا رسوم شبكة إضافية، ولا اشتراك.' },
    { q: 'هل تحوزون أموالي؟', a: 'لا. ShieldMyAss غير حافظ. تُرسل العملات إلى عنوان إيداع لمرة واحدة مُولَّد لصفقتك، وتبدّلها الشبكة، ويُرسَل الناتج مباشرةً إلى محفظتك. لا نحتفظ بأرصدة نيابةً عنك أبداً.' },
    { q: 'ماذا يحدث إذا أرسلت عملة خاطئة؟', a: 'تحقّق دائماً من أنّ عنوان الإيداع يطابق العملة والشبكة اللذين اخترتهما. قد يؤدّي إرسال أصل خاطئ إلى عنوان الإيداع إلى خسارة دائمة. إذا أخطأت، تواصل فوراً مع دعم ChangeNOW عبر changenow.com/contact وأرسل مُعرّف معاملتك — الاسترداد ممكن أحياناً لكن غير مضمون.' },
    { q: 'هل هناك حد أدنى أو أقصى لحجم الصفقة؟', a: 'نعم — لكل زوج حد أدنى للشبكة (غالباً ما يعادل بضعة دولارات) يظهر حيّاً في أداة المبادلة. لا يوجد حد أقصى صارم، لكن قد تُقسَّم الصفقات الكبيرة جداً عبر مصادر سيولة لتجنّب تحريك السوق.' },
    { q: 'ما العملات الرقمية المدعومة؟', a: 'أكثر من 900 عملة عبر أكثر من 30 بلوك تشين، تشمل بيتكوين وإيثيريوم وسولانا ومونيرو ولايتكوين و BNB وتذر (USDT) ويو إس دي كوين (USDC) وتذر غولد (XAUT) ومئات من رموز ERC-20 و BEP-20 و SPL. تصفّح القائمة الكاملة في صفحة العملات المدعومة.' },
    { q: 'هل يمكنني الحصول على استرداد؟', a: 'إذا فشلت المبادلة على جانب الشبكة، يُعاد المبلغ الصادر تلقائياً إلى العنوان الذي أتيت منه. إذا أدخلت عنوان استلام غير صحيح، تواصل مع دعم ChangeNOW عبر changenow.com/contact وأرسل مُعرّف معاملتك — يعتمد الاسترداد على ما إذا كان قد بُثَّ الإخراج بالفعل.' },
  ],
  featuredBlurbs: {
    btc: 'عملة القيمة المخزّنة الأصلية وأكثر أزواج التداول سيولةً على ShieldMyAss.',
    eth: 'أموال قابلة للبرمجة تُشغّل DeFi و NFT وأغلب مبادلات الرموز.',
    sol: 'شبكة من الطبقة الأولى عالية الإنتاجية، معروفة بالنهائية السريعة والرسوم المنخفضة.',
    xmr: 'عملة رقمية تعطي الأولوية للخصوصية مع إخفاء إلزامي بتوقيعات حلقيّة.',
    ltc: 'فضّة بيتكوين — تأكيدات سريعة ودعم واسع للمحفظة منذ 2011.',
    bnb: 'الأصل الأصلي لمنظومة BNB Chain وأحد أبرز رموز البورصات.',
    usdt_trx: 'العملة المستقرة بالدولار الأكثر اعتماداً، تُنقَل بتكلفة منخفضة على شبكة ترون.',
    usdc_eth: 'عملة مستقرة بالدولار مغطّاة بالكامل وتُصدرها Circle على إيثيريوم.',
    xaut: 'أونصة واحدة من الذهب المادي، مُرمَّزة وقابلة للاسترداد على السلسلة.',
  },
};

export default ar;
